import { DomainSchema } from '@multitec/domain'
import { useQuery } from 'react-query'
import { z } from 'zod'

import { Base } from '../base'
import { MyURLSearchParams } from '../utils/url-search-params'

class Create extends Base {
  private body = z.object({
    personId: z.string(),
    name: z.string(),
    phone: z.string().optional(),
    email: z.string().optional(),
    role: z.string().optional(),
  })

  private response = z.object({
    id: z.string(),
  })

  handle = async (body: z.infer<typeof this.body>) => {
    const { data } = await this.axios.post('/entity/person-contacts/', body)
    return this.response.parse(data.result)
  }
}

class Edit extends Base {
  private body = z.object({
    name: z.string(),
    phone: z.string().optional(),
    email: z.string().optional(),
    role: z.string().optional(),
    active: z.boolean(),
  })

  private response = z.object({
    id: z.string(),
  })

  handle = async (id: string, body: z.infer<typeof this.body>) => {
    const { data } = await this.axios.put('/entity/person-contacts/' + id, body)
    return this.response.parse(data.result)
  }
}

class Delete extends Base {
  handle = async (id: string) => {
    await this.axios.delete('/entity/person-contacts/' + id)
  }
}

class LoadByPerson extends Base {
  private response = z.array(DomainSchema.PersonContact)

  handle = (personId: string) => {
    return useQuery(
      ['person-contact', 'load-by-person', { personId }],
      async () => {
        const queryParams = new MyURLSearchParams({ personId }).toString()
        const { data } = await this.axios.get(
          '/entity/person-contacts?' + queryParams,
        )
        return this.response.parse(data.result)
      },
    )
  }
}

class LoadOne extends Base {
  private response = DomainSchema.PersonContact

  handle = (id: string) => {
    return useQuery(['person-contact', 'load-one', { id }], async () => {
      const { data } = await this.axios.get('/entity/person-contacts/' + id)
      return this.response.parse(data.result)
    })
  }
}

export default class extends Base {
  Create = new Create(this.axios).handle
  Edit = new Edit(this.axios).handle
  Delete = new Delete(this.axios).handle
  LoadByPerson = new LoadByPerson(this.axios).handle
  LoadOne = new LoadOne(this.axios).handle
}
